const R = require('ramda')
const u = require('@mediatool/mt-utils/import')
const crudFuture = require('./crud-future')
const httpFuture = require('../lib/http-future')

const getEntityPathName = R.compose(
  u.pluralize,
  R.toLower
)

const buildURI = R.join('/')
const createEntitiesURI = R.curry((path, orgId) => buildURI([ '/organizations', orgId, path ]))

function orgEntityFuture (camelCasePath) {
  const getEntities = R.map(R.path([ 'body', u.pluralize(camelCasePath) ]))
  const entityPath = getEntityPathName(camelCasePath)

  const self = crudFuture(camelCasePath, entityPath)

  self.getForOrg = R.compose(
    getEntities,
    httpFuture.get,
    createEntitiesURI(entityPath)
  )

  self.search = R.compose(
    getEntities,
    httpFuture.getWithQuery(`/${entityPath}`),
    (query) => ({ q: JSON.stringify(query) })
  )

  return self
}

module.exports = orgEntityFuture
